export default {
      id: "angleRight-usage",
      viewBox: "0 0 14 14",
      url: "assets/" + "sprite.svg#angleRight-usage",
      toString: function () {
        return this.url;
      }
    }